import React from 'react';

import Contact from '../../../../helpers/uiComponents/Contact';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

export class Contacts extends React.Component {

	render() {
		const contacts = this.props.currentClient.contacts.filter( cont => { return cont.type !== "billing"; });
		const locations = this.props.currentClient.locations.filter( loc => { return loc.type !== "billing"; });
		return(
			<div className="input-group">
				<AccordianTitle title={"Contacts"} />
				<div className="accordian-body">
					<Contact
						contacts={contacts}
						clientCode={this.props.currentClient.clientCode}
						type={null}
						container={"contact"}
						locations={locations}
					/>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Contacts.js